(ns app.routes
  (:require
   [bidi.bidi :as bidi]
   [pushy.core :as pushy]
   [re-frame.core :as re-frame]
   [app.events :as events]))

(defmulti panels #(do  %))
(defmethod panels :default [] [:div ""])

(def routes
  (atom
   ["/" {""      :home-page
         "login" :login
         "sign-up" :sign-up
         "forgot-password" :forgot-password
         "reset-password" :reset-password
         "reset-password-email" :reset-password-email
         "reset-password-success" :reset-password-success
         "verify-email" :verify-email
         "workspace/new" :new-workspace
         "dashboard" {"" :dashboard
                      ["/" :id] {"" :dashboard-view
                                 "/settings" :workspace-settings
                                 "/account" :account-settings
                                 "/editors" :members-view
                                 "/trash" {"" :trash-view
                                           ["/folder/" :folder-id] :deleted-folder-view}}
                      ["/" :id "/folder/" :folder-id] :folder-view}
         "strive-forms" :strive-forms}]))

(defn parse
  [url]
  (bidi/match-route @routes url))

(defn url-for
  [& args]
  (apply bidi/path-for (into [@routes] args)))

(defn keyword-concat [k s]
  (keyword (str (name k) s)))

(defn dispatch
  [route]
  (re-frame/dispatch [::events/set-route {:route route
                                          :panel (keyword-concat (:handler route) "-panel")}]))

(defonce history
  (pushy/pushy dispatch parse))

(defn navigate-fun! [url]
  (pushy/replace-token! history url))

(defn navigate!
  [handler]
  (pushy/set-token! history (apply url-for handler)))

(defn start!
  []
  (pushy/start! history))

(re-frame/reg-fx
 :navigate
 (fn [handler]
   (navigate! handler)))
